/* eslint-disable @next/next/no-img-element */
import Image from 'next/image';
import Slider from "react-slick";
import { useState } from 'react';
import { IMG_URL } from "../../../utilities/constants";
import Tag from "components/cong-dong/chi-tiet/image-tag";
import { isArray } from 'lodash';
import ImageComponentWithTag from 'components/cong-dong/chi-tiet/imageComponentWithTagShow';
import VendorImageComponent from 'components/shop/profile/vendorImageComponent';

export default function SlideImage({ images }) {
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const settingsDetail1 = {
        arrows: false,
        dots: false,
        fade: true,
        adaptiveHeight: true,
        asNavFor: nav2,
        ref: (slider) => setNav1(slider)
    };

    const settingsDetail2 = {
        speed: 500,
        slidesToShow: 7,
        infinite: true,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        asNavFor: nav1,
        ref: (slider) => setNav2(slider),
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5,
                }
            }
        ]
    };

    const genBigImage = images.map((img, index) => (
        // <ImageComponentWithTag key={index} image={img}/>
        <VendorImageComponent key={index} item={img} anhTo={true}/>
    ));

    const genSmallImage = images.map((img, index) => (
        <div key={index} className="photoGallery-small wrap-next-image">
            {/* <img src={img.storage_url} alt={img.name} /> */}
            <Image layout="fill" src={img.storage_url} alt={img.name} />
        </div>
    ));

    return (
        <div className="sliderPhoto">
            <div className="slider slider-thumb">
                <Slider {...settingsDetail1}>
                    {genBigImage}
                </Slider>
            </div>
            <div className="slider slider-sub-small slider-sub">
                <Slider {...settingsDetail2}>
                    {genSmallImage}
                </Slider>
            </div>
        </div>
    );
};